module.exports = __webpack_public_path__ + "static/media/menu-profile.173d3d03.svg";